export enum MessageType {
  Message= "Message",
  Typing= "Typing",
}